<div
  class="validation-wrapper"
  [validation-error]="control"
  [mapKeys]="mapKeys"
  [data-id]='id'
>
  <ng-content></ng-content>
</div>
